import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Template } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useCreateTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (templateData: Partial<Template>): Promise<Template> => {
      const { data } = await request({
        path: `template/add`,
        method: 'POST',
        authenticate: true,
        dataObject: templateData,
      });
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-templates'] });
      toast.success('Template created successfully!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error creating template!');
    },
  });
};
